/*eslint-disable no-useless-escape, no-undef, no-unused-vars*/
'use strict'
import $ from 'jquery';
import {isNil} from 'lodash';

  	var notAllowMail = [
  		  				"docomo.ne.jp",							
  		  				"mopera.net",							
  		  				"dwmail.jp",							
  		  				"softbank.ne.jp",							
  		  				"i.softbank.jp",							
  		  				"disney.ne.jp",							
  		  				"d.vodafone.ne.jp",							
  		  				"h.vodafone.ne.jp",							
  		  				"t.vodafone.ne.jp",							
  		  				"c.vodafone.ne.jp",							
  		  				"r.vodafone.ne.jp",							
  		  				"k.vodafone.ne.jp",							
  		  				"n.vodafone.ne.jp",							
  		  				"s.vodafone.ne.jp",							
  		  				"q.vodafone.ne.jp",							
  		  				"jp-d.ne.jp",							
  		  				"jp-h.ne.jp",							
  		  				"jp-t.ne.jp",							
  		  				"jp-c.ne.jp",							
  		  				"jp-r.ne.jp",							
  		  				"jp-k.ne.jp",							
  		  				"jp-n.ne.jp",							
  		  				"jp-s.ne.jp",							
  		  				"jp-q.ne.jp",							
  		  				"ezweb.ne.jp",							
  		  				"ido.ne.jp",							
  		  				"ezweb.ne.jp",							
  		  				"ezweb.ne.jp",							
  		  				"sky.tkk.ne.jp",							
  		  				"sky.tkc.ne.jp",							
  		  				"sky.tu-ka.ne.jp",							
  		  				"pdx.ne.jp",							
  		  				"di.pdx.ne.jp",							
  		  				"dj.pdx.ne.jp",							
  		  				"dk.pdx.ne.jp",							
  		  				"wm.pdx.ne.jp",							
  		  				"willcom.com",							
  		  				"wcm.ne.jp",							
  		  				"emnet.ne.jp",							
  		  				"emobile.ne.jp"							
  		  			];
	  
  	var self = new Object();
  	self.isBlank = function(value){
  		return $.trim(value)  ? false : true;
  	}
  	
  	self.trim = function(value){
  		return $.trim(value);
  	}
  	
  	self.isEmail = function(value){
  		var result = false;
  		var isValidFormat = !self.isBlank(value) 
  			&& (/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*(\.[A-Za-z0-9]{1,})$/.test(value));
  		if(isValidFormat){
  			var indexDot = value.lastIndexOf(".");
  			if(indexDot > 0) {
  				result = true;
  			}
  		}
  		return result;
  			/*&& notAllowMail.indexOf(value.split("@")[1]) == -1);*/
  	}
  	self.isBlackListEmail = function(value){
  		return self.isBlank(value) || notAllowMail.indexOf(value.split("@")[1]) == -1;
  	}
  	
  	self.isValidDateFormat = function(input, pattern){
  		if(!self.isBlank(input)){
    		 return moment(input, pattern, true).isValid();
    	}
  		return true;
  	}
  	
  	self.isHalfWidth = function(str1) {
  		return str1 && ('\u0020' <= str1 && str1 <= '\u007F') || ('\uFF61' <= str1 && str1 <= '\uFF9F');
  	}
  	
  	self.isContainHalfWidth = function(str){
  		if (str == null || str.length<=0) {
  			return false;
  		}
  		str = self.trim(str);
  		
  		for(var i=0; i<str.length; i++) {
  			var str1=str.charAt(i);
  			if(self.isHalfWidth(str1)){
  				return true;
  			}
  		}
  		return false;
  	}
  	self.checkFileTypeImageIsValid = function(fileName, allowFileUpload){
		var result = false;
		var fileImageValid;
		var indexDot = fileName.lastIndexOf(".");
		var fileExtension = fileName.substring(indexDot);
		for ( var index in allowFileUpload) {
			if(fileExtension.toUpperCase()  == allowFileUpload[index].trim().toUpperCase() ){
				result = true;
    			break;
    		}
		}
		return result;
	};
	self.isNull = function(obj){
		var result = false;
		if(typeof obj == "undefined" || obj == null){
			result = true;
		}
		return result;
	}

	const blackListDomains = process.env.VUE_APP_EMAIL_BLACK_LIST.split(',').map(item => item.replace(/\s/g, ''));
	self.validateSpecificMailFormat = function(value) {
		let result = false;
		let isValidFormat = !self.isBlank(value);

		if (isNil(blackListDomains)) {
			return true;
		}

		for (let i = 0; i < blackListDomains.length; i++) {
			let domain = blackListDomains[i];
			isValidFormat = isValidFormat && !new RegExp(domain + "\\s*$").test(value);
		}

		if (isValidFormat) {
			var indexDot = value.lastIndexOf('.');
			if (indexDot > 0) {
				result = true;
			}
		}

		return result;
	}
export default self;
